import { BackToListButton } from '@/features/missions/components/BackToListButton'
import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { useMissionRedirect } from '@/features/missions/hooks/useMissionRedirect'
import { Trans } from '@lingui/react/macro'
import { useNavigate, useParams } from 'react-router-dom'
import { ProficiencyAssessmentFlow } from './proficiency-assessment/ProficiencyAssessmentFlow'

export const AssessmentTask = () => {
  const { langCode = 'en' } = useParams<{ langCode: string }>()
  const { missionsUrl } = useMissionsUrl()
  const { redirect } = useMissionRedirect()
  const navigate = useNavigate()

  const backUrl = redirect ?? missionsUrl

  return (
    <div className="mb-10 flex flex-col gap-6 py-8">
      <BackToListButton href={backUrl} text={<Trans>Back to Mission</Trans>} />
      <ProficiencyAssessmentFlow
        language={langCode}
        captchaEnabled={false}
        taskReportingEnabled={false}
        onBack={() => navigate(backUrl)}
        onCompleted={() => navigate(backUrl)}
        /** */
        projectName={'Proficiency Assessment'}
        progress={{ completed: 0, total: 0 }}
        maxTasksPerUser={0}
      />
    </div>
  )
}
